import { useNavigate } from 'react-router-dom';
import NavigationRoutes from '../../../../Layouts/NavigationRoutes';
import LinkButton, { LinkButtonType } from '../../../Components/Form/Buttons/LinkButton';
import useLanguage from '../../../Services/Language/useLanguageHook';
import styles from '../ChartBuilder.module.scss';

const ChartBuilderCreateChartAction: React.FC = () => {
    // Application hooks.
    const [translations] = useLanguage();
    const navigate = useNavigate();

    const navigateToCreateCustomChartPage = () => navigate(NavigationRoutes.ChartBuilder);

    return (
        <div className={styles.coverage_levels_actions}>
            <LinkButton
                title={translations.chartBuilder.text.createChart}
                type={LinkButtonType.Blue}
                onClick={navigateToCreateCustomChartPage}
                track={{ eventCategory: 'ChartBuilder', eventAction: 'CreateChartClicked' }}
            />
        </div>
    );
};

export default ChartBuilderCreateChartAction;
